/**
 * VidaFIT Theme JavaScript
 */

// Mobile menu toggle
document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('[data-mobile-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  toggles.forEach(btn => {
    btn.addEventListener('click', () => {
      if (mobileNav) mobileNav.classList.toggle('is-open');
    });
  });

  // Close mobile nav on backdrop click
  if (mobileNav) {
    mobileNav.addEventListener('click', (e) => {
      if (e.target === mobileNav) mobileNav.classList.remove('is-open');
    });
  }

  // Productos destacados: carrusel con flechas, viñetas y rotación automática
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-featured-carousel]').forEach(carousel => {
    const track = carousel.querySelector('[data-carousel-track]');
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;

    const cards = [...track.querySelectorAll('.product-card')];
    const dots = [...carousel.querySelectorAll('.featured-products__dot')];
    const delay = parseInt(carousel.dataset.autoplay, 10) || 0;
    let timer = null;
    let paused = false;

    const step = () => {
      const card = cards[0];
      return card ? card.offsetWidth + parseFloat(getComputedStyle(track).columnGap) : track.clientWidth;
    };
    const atStart = () => track.scrollLeft <= 1;
    const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;

    // Las flechas dan la vuelta: al final regresan al inicio y viceversa
    const goNext = () => track.scrollTo({ left: atEnd() ? 0 : track.scrollLeft + step() });
    const goPrev = () => track.scrollTo({ left: atStart() ? track.scrollWidth : track.scrollLeft - step() });

    const start = () => {
      clearInterval(timer);
      if (!delay || reduceMotion || carousel.classList.contains('is-static')) return;
      timer = setInterval(() => {
        if (!paused && !document.hidden) goNext();
      }, delay);
    };

    // Viñetas: se resaltan los productos que están a la vista
    if (dots.length) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const dot = dots[cards.indexOf(entry.target)];
          if (dot) dot.classList.toggle('is-active', entry.isIntersecting);
        });
      }, { root: track, threshold: 0.6 });
      cards.forEach(card => observer.observe(card));

      dots.forEach((dot, i) => dot.addEventListener('click', () => {
        if (cards[i]) track.scrollTo({ left: cards[i].offsetLeft - cards[0].offsetLeft });
        start();
      }));
    }

    const updateStatic = () => {
      carousel.classList.toggle('is-static', track.scrollWidth <= track.clientWidth + 1);
    };

    prev.addEventListener('click', () => { goPrev(); start(); });
    next.addEventListener('click', () => { goNext(); start(); });

    // Pausar mientras el usuario interactúa
    carousel.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') paused = true; });
    carousel.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') paused = false; });
    carousel.addEventListener('focusin', e => { if (e.target.matches(':focus-visible')) paused = true; });
    carousel.addEventListener('focusout', () => { paused = false; });
    track.addEventListener('touchstart', () => { paused = true; }, { passive: true });
    track.addEventListener('touchend', () => { paused = false; start(); }, { passive: true });

    window.addEventListener('resize', () => { updateStatic(); start(); });
    updateStatic();
    start();
  });

  // WhatsApp bubble: mostrar tooltip una vez por sesión tras ~3s
  const waTip = document.getElementById('wa-tip');
  const waClose = document.getElementById('wa-close');
  const waLink = document.getElementById('wa-link');
  if (waTip) {
    const dismiss = () => {
      waTip.classList.remove('is-visible');
      try { sessionStorage.setItem('waTipSeen', '1'); } catch (e) {}
    };
    let seen = false;
    try { seen = sessionStorage.getItem('waTipSeen') === '1'; } catch (e) {}
    if (!seen) {
      setTimeout(() => waTip.classList.add('is-visible'), 3000);
    }
    if (waClose) waClose.addEventListener('click', dismiss);
    if (waLink) waLink.addEventListener('click', dismiss);
  }
});
